export const routes = {
  health: "/healthz",
  auth: {
    appleChallenge: "/api/auth/apple/challenge",
    appleSignIn: "/api/auth/apple",
    register: "/api/auth/register",
    passwordSignIn: "/api/auth/password",
    verifyEmail: "/api/auth/verify-email",
    forgotPassword: "/api/auth/password/forgot",
    resetPassword: "/api/auth/password/reset",
    social: "/api/auth/social",
    connect: "/api/auth/connect",
    handoff: "/api/auth/handoff",
    linkHandoff: "/api/auth/handoff/link",
    logout: "/api/auth/logout",
    me: "/api/auth/me",
    deleteData: "/api/auth/data"
  },
  banks: {overview: "/api/banks", connect: "/api/banks/connections", complete: "/api/banks/connections/complete", refresh: "/api/banks/refresh", syncStatus: "/api/banks/sync-status", disconnect: "/api/banks/disconnect", reconnect: "/api/banks/reconnect"},
  chat: {conversations: "/api/chat/conversations", messages: "/api/chat/messages", stop: "/api/chat/stop", suggestions: "/api/chat/suggestions"},
  insights: {summary: "/api/insights", transactions: "/api/insights/transactions"},
  engagement: {
    show: "/api/engagement",
    checkIns: "/api/engagement/check-ins",
    events: "/api/engagement/events",
    preferences: "/api/engagement/preferences",
    recap: "/api/engagement/recap",
    wrapped: "/api/engagement/wrapped",
    roast: "/api/engagement/roast",
    snapshot: "/api/engagement/snapshot",
    widgetToken: "/api/engagement/widget-token"
  },
  devices: {register: "/api/devices", remove: "/api/devices/remove"},
  liveActivities: {register: "/api/live-activities", end: "/api/live-activities/end"},
  referrals: {show: "/api/referrals", apply: "/api/referrals/apply"},
  billing: {entitlement: "/api/billing/entitlement", plans: "/api/billing/plans", apple: "/api/billing/apple", checkout: "/api/billing/checkout", portal: "/api/billing/portal"},
  webhooks: {plaid: "/webhooks/plaid", appStore: "/webhooks/app-store", stripe: "/webhooks/stripe"}
} as const;

export const queryKeys = {
  me: ["me"] as const,
  banks: (userId: string) => ["banks", userId] as const,
  syncStatus: (userId: string) => ["sync-status", userId] as const,
  conversations: (userId: string) => ["conversations", userId] as const,
  conversation: (userId: string, conversationId: string) => ["conversation", userId, conversationId] as const,
  suggestions: (userId: string, conversationId: string | null = null) => ["chat-suggestions", userId, conversationId] as const,
  insights: (userId: string) => ["insights", userId] as const,
  spendingTransactions: (userId: string) => ["spending-transactions", userId] as const,
  engagement: (userId: string) => ["engagement", userId] as const,
  recap: (userId: string) => ["engagement-recap", userId] as const,
  wrapped: (userId: string, period: string) => ["engagement-wrapped", userId, period] as const,
  roast: (userId: string) => ["engagement-roast", userId] as const,
  referrals: (userId: string) => ["referrals", userId] as const
};

export type RouteName = keyof typeof routes;
